import React, { useEffect, useState, useRef } from "react";
import Input from "../Common/CustomInput";
import CustomSelect from "../Common/CustomSelect";
import api from "../../setupMiddleware";
import Loader from "../Loader/Loader";
import useApiLoader from "../../Utils/useApiLoader";
import { ToastContainer, toast, Bounce } from "react-toastify";
import PasswordRules from "../Common/PasswordRule";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import FileUpload from "../Common/FileUpload";
import { createFormData, getCountryList } from "../../Utils/getUserUtitls";
import Textarea from "../Common/Textarea";
import { getUser } from "../../Utils/auth";
import { useLayout } from "./LayoutContext";

const AddEmployee = () => {
  const { layoutRef } = useLayout();
  const navigate = useNavigate();
  const loading = useApiLoader();
  const [roleData, setRoleData] = useState([]);
  const [designationData, setDesignationData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [gradeData, setGradeData] = useState([]);
  const [tlData, setTlData] = useState([]);
  const [hrData, setHrData] = useState([]);
  const [managerData, setManagerData] = useState([]);
  const [passwordShown, setPasswordShown] = useState(false);
  const [sameAddress, setSameAddress] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});

  const loggedUser = getUser();

  const handleClickShowPassword = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const designationOptions = designationData?.map((des) => ({
    label: des.title,
    value: des.id,
  }));

  const roleOptions = roleData?.map((ro) => ({
    label: ro.name,
    value: ro.id,
  }));

  const departmentOptions = departmentData?.map((dep) => ({
    label: dep.name,
    value: dep.id,
  }));

  const locationOptions = locationData?.map((loc) => ({
    label: loc.name,
    value: loc.id,
  }));

  const gradeOptions = gradeData?.map((grd) => ({
    label: grd.title,
    value: grd.id,
  }));
  const tlOptions = tlData?.map((tl) => ({
    label: tl.first_name + " " + tl.last_name,
    value: tl.id,
  }));

  const hrOptions = hrData?.map((hr) => ({
    label: hr.first_name + " " + hr.last_name,
    value: hr.id,
  }));

  const managerOptions = managerData?.map((mr) => ({
    label: mr.first_name + " " + mr.last_name,
    value: mr.id,
  }));

  const genderOptions = [
    {
      label: "Male",
      value: "male",
    },
    {
      label: "Female",
      value: "female",
    },
    {
      label: "Other",
      value: "other",
    },
  ];

  const maritalStatusOptions = [
    {
      label: "Single",
      value: "Single",
    },
    {
      label: "Married",
      value: "Married",
    },
    {
      label: "Separated/Divorced",
      value: "Separated/Divorced",
    },
  ];

  const nationalityOptions = getCountryList();

  const [employee, setEmployee] = useState({
    employee_image: null,
    username: "",
    first_name: "",
    last_name: "",
    middle_name: "",
    office_email: "",
    emergency_contact: "",
    father_name: "",
    mother_name: "",
    place_of_birth: "",
    marital_status: "",
    password: "",
    con_password: "",
    dob: "",
    gender: "",
    email: "",
    phone: "",
    emergency_contact: "",
    current_address: "",
    permanent_address: "",
    nationality: "",
    salary: "",
    designation_id: null,
    department_id: null,
    tl_id: 0,
    grade_id: 0,
    emirate_id: "",
    location_id: null,
    role_id: null,
    joining_date: "",
    hr_head: null,
    manager: null,
    hr_id: 0,
    bank_account_number: "",
    employee_personal_number: "",
    bank_routing_code: "",
    passport_no: "",
    adharcard_no: "",
    ifsc_code: "",
  });

  const {
    employee_image,
    username,
    first_name,
    last_name,
    father_name,
    mother_name,
    place_of_birth,
    marital_status,
    middle_name,
    office_email,
    password,
    con_password,
    dob,
    gender,
    email,
    phone,
    emergency_contact,
    permanent_address,
    current_address,
    nationality,
    salary,
    grade_id,
    designation_id,
    department_id,
    tl_id,
    location_id,
    role_id,
    joining_date,
    hr_head,
    manager,
    hr_id,
    bank_account_number,
    employee_personal_number,
    bank_routing_code,
    emirate_id,
    passport_no,
    adharcard_no,
    ifsc_code,
  } = employee;

  console.log(employee);

  // Password rule checks
  const minchar = password.length >= 8;
  const upcase = /[A-Z]/.test(password);
  const lowcase = /[a-z]/.test(password);
  const number = /[0-9]/.test(password);
  const special = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  const getAllData = async () => {
    api.get("/api/master-data").then((res) => {
      if (res && res.status === 200) {
        const resData = res.data?.data;
        const filteredRoleData = resData?.roles.filter((item) => {
          // Always remove id=1
          if (item.id === 1) return false;

          // If logged-in user is NOT 1, also remove id=2
          if (loggedUser?.id !== 1 && item.id === 2) return false;

          return true; // keep everything else
        });
        setRoleData(filteredRoleData);
        setDesignationData(resData?.designations);
        setDepartmentData(resData?.departments);
        // setLocationData(resData?.data);
        setGradeData(resData?.grades);
        setTlData(resData?.team_leaders);
        setHrData(resData?.hrs);
        setManagerData(resData?.managers);
      }
    });
  };

  // const getAllDesignations = async () => {
  //   api.get("/api/designations").then((res) => {
  //     if (res && res.status === 200) {
  //       setDesignationData(res.data);
  //     }
  //   });
  // };

  // const getAllDepartments = async () => {
  //   api.get("/api/departments").then((res) => {
  //     if (res && res.status === 200) {
  //       setDepartmentData(res.data);
  //     }
  //   });
  // };

  const getAllLocation = async () => {
    api.get("/api/locations").then((res) => {
      if (res && res.status === 200) {
        setLocationData(res.data?.data);
      }
    });
  };

  // const getAllGrades = async () => {
  //   api.get("/api/grades").then((res) => {
  //     if (res && res.status === 200) {
  //       setGradeData(res.data?.data);
  //     }
  //   });
  // };

  // const getAllTeamLeaders = async () => {
  //   api.get("/api/team-leaders").then((res) => {
  //     if (res && res.status === 200) {
  //       setTlData(res.data?.data);
  //     }
  //   });
  // };

  useEffect(() => {
    getAllData();
    // getAllDesignations();
    // getAllDepartments();
    getAllLocation();
    // getAllGrades();
    // getAllTeamLeaders();
  }, []);

  const validateFields = () => {
    const newErrors = {};

    if (!employee_image) newErrors.employee_image = ["Please upload a file"];
    if (!username) newErrors.username = ["Username is required"];
    if (!first_name) newErrors.first_name = ["First name is required"];
    if (!last_name) newErrors.last_name = ["Last name is required"];
    if (!email) newErrors.email = ["Email is required"];
    if (!password) newErrors.password = ["Password is required"];
    if (!role_id) newErrors.role_id = ["Role is required"];
    if (!department_id) newErrors.department_id = ["Department is required"];
    if (!grade_id) newErrors.grade_id = ["Grade is required"];
    if (!salary) newErrors.salary = ["Salary is required"];
    if (location_id === 1 && !emirate_id)
      newErrors.emirate_id = ["Emirates ID is required"];
    if (location_id === 2 && !adharcard_no)
      newErrors.emirate_id = ["Adhaar Card Number is required"];

    if (password && (!minchar || !upcase || !lowcase || !number || !special)) {
      newErrors.password = ["Password must meet all of the rules listed below"];
    }

    if (password !== con_password) {
      newErrors.con_password = ["Password and confirm password do not match"];
    }

    setFieldErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const resetErrors = () => setFieldErrors({});

  const handleAddEmployee = async () => {
    resetErrors();

    // run frontend validation
    if (!validateFields()) {
      window.scrollTo(0, 0);
      return; // stop if errors exist
    }

    try {
      const formData = createFormData(employee);
      await api.post("/api/add-employee", formData).then((res) => {
        if (res && res.status === 201) {
          toast.success(res.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
          setTimeout(() => navigate("/employees"), 1000);
        }
      });
    } catch (err) {
      if (err) {
        toast.error(err.response.data.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
        setFieldErrors(err.response.data.errors); // same shape
        window.scrollTo(0, 0);
      }
    }
  };

  const handleSameAddress = () => {
    if (!sameAddress) {
      setEmployee({ ...employee, current_address: permanent_address });
      setSameAddress(!sameAddress);
    } else {
      setEmployee({ ...employee, current_address: "" });
      setSameAddress(!sameAddress);
    }
  };

  useEffect(() => {
    if (fieldErrors && layoutRef.current) {
      layoutRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [fieldErrors]);

  return (
    <>
      {loading && <Loader opacity={90} fullscreen />}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full mx-auto px-4 py-3 gap-4">
        {/* Left Content */}
        <p>
          <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
            Add Employee
          </span>
          <span className="block text-sm text-[#142b70]/50">
            Fill All the Employee Details
          </span>
        </p>
      </div>
      <div className="w-full mx-auto px-4 py-3 relative">
        <div className="w-full mx-auto p-8 relative rounded-3xl bg-white border border-[#a48572]/10">
          <div className="flex flex-col lg:flex-row flex-grow justify-start items-start gap-[60px]">
            {/* Form Col 1*/}
            <div className="flex flex-col flex-grow gap-6 w-full">
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <div className="relative">
                    <FileUpload
                      label="Profile Photo"
                      accept="image/*"
                      multiple={false}
                      onChange={(file) => {
                        setEmployee({ ...employee, employee_image: file });
                        if (fieldErrors.employee_image) {
                          setFieldErrors({
                            ...fieldErrors,
                            employee_image: undefined,
                          });
                        }
                      }}
                      error={Boolean(fieldErrors.employee_image)}
                      helperText={fieldErrors?.employee_image?.[0]}
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">First Name</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter First name"
                      value={first_name}
                      onChange={(e) => {
                        setEmployee({
                          ...employee,
                          first_name: e.target.value,
                        });
                        if (fieldErrors.first_name) {
                          setFieldErrors({
                            ...fieldErrors,
                            first_name: undefined,
                          });
                        }
                      }}
                      error={Boolean(fieldErrors.first_name)}
                      helperText={fieldErrors?.first_name?.[0]}
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Middle Name</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Middle name"
                      value={middle_name}
                      onChange={(e) =>
                        setEmployee({
                          ...employee,
                          middle_name: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Last Name</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Last name"
                      value={last_name}
                      onChange={(e) => {
                        setEmployee({
                          ...employee,
                          last_name: e.target.value,
                        });
                        if (fieldErrors.last_name) {
                          setFieldErrors({
                            ...fieldErrors,
                            last_name: undefined,
                          });
                        }
                      }}
                      error={Boolean(fieldErrors.last_name)}
                      helperText={fieldErrors?.last_name?.[0]}
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Father Name</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Father Name"
                      value={father_name}
                      onChange={(e) => {
                        setEmployee({
                          ...employee,
                          father_name: e.target.value,
                        });
                        if (fieldErrors.father_name) {
                          setFieldErrors({
                            ...fieldErrors,
                            father_name: undefined,
                          });
                        }
                      }}
                      error={Boolean(fieldErrors.father_name)}
                      helperText={fieldErrors?.father_name?.[0]}
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Mother Name</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Mother Name"
                      value={mother_name}
                      onChange={(e) => {
                        setEmployee({
                          ...employee,
                          mother_name: e.target.value,
                        });
                        if (fieldErrors.mother_name) {
                          setFieldErrors({
                            ...fieldErrors,
                            mother_name: undefined,
                          });
                        }
                      }}
                      error={Boolean(fieldErrors.mother_name)}
                      helperText={fieldErrors?.mother_name?.[0]}
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Username</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Username"
                      value={username}
                      onChange={(e) => {
                        setEmployee({ ...employee, username: e.target.value });
                        if (fieldErrors.username) {
                          setFieldErrors({
                            ...fieldErrors,
                            username: undefined,
                          });
                        }
                      }}
                      error={Boolean(fieldErrors.username)}
                      helperText={fieldErrors?.username?.[0]}
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Personal Email</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Email"
                      value={email}
                      onChange={(e) => {
                        setEmployee({
                          ...employee,
                          email: e.target.value,
                        });
                        if (fieldErrors.email) {
                          setFieldErrors({
                            ...fieldErrors,
                            email: undefined,
                          });
                        }
                      }}
                      error={Boolean(fieldErrors.email)}
                      helperText={fieldErrors?.email?.[0]}
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Office Email</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Office Email"
                      value={office_email}
                      onChange={(e) => {
                        setEmployee({
                          ...employee,
                          office_email: `${e.target.value}`,
                        });
                        if (fieldErrors.office_email) {
                          setFieldErrors({
                            ...fieldErrors,
                            office_email: undefined,
                          });
                        }
                      }}
                      error={Boolean(fieldErrors.office_email)}
                      helperText={fieldErrors?.office_email?.[0]}
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Emergency Contact</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Emergency Contact"
                      value={emergency_contact}
                      onChange={(e) => {
                        setEmployee({
                          ...employee,
                          emergency_contact: e.target.value,
                        });
                        if (fieldErrors.emergency_contact) {
                          setFieldErrors({
                            ...fieldErrors,
                            emergency_contact: undefined,
                          });
                        }
                      }}
                      error={Boolean(fieldErrors.emergency_contact)}
                      helperText={fieldErrors?.emergency_contact?.[0]}
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Phone Number</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Phone Number"
                      value={phone}
                      onChange={(e) => {
                        setEmployee({
                          ...employee,
                          phone: `${e.target.value}`,
                        });
                        if (fieldErrors.phone) {
                          setFieldErrors({
                            ...fieldErrors,
                            phone: undefined,
                          });
                        }
                      }}
                      error={Boolean(fieldErrors.phone)}
                      helperText={fieldErrors?.phone?.[0]}
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Date of Birth</p>
                  <div className="relative">
                    <Input
                      type="date"
                      placeholder="Enter DOB"
                      value={dob}
                      onChange={(e) => {
                        setEmployee({ ...employee, dob: e.target.value });
                        if (fieldErrors.dob) {
                          setFieldErrors({
                            ...fieldErrors,
                            dob: undefined,
                          });
                        }
                      }}
                      error={Boolean(fieldErrors.dob)}
                      helperText={fieldErrors?.dob?.[0]}
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Date of Joining</p>
                  <div className="relative">
                    <Input
                      type="date"
                      placeholder="Enter Date of Joining"
                      value={joining_date}
                      onChange={(e) => {
                        setEmployee({
                          ...employee,
                          joining_date: e.target.value,
                        });
                        if (fieldErrors.joining_date) {
                          setFieldErrors({
                            ...fieldErrors,
                            joining_date: undefined,
                          });
                        }
                      }}
                      error={Boolean(fieldErrors.joining_date)}
                      helperText={fieldErrors?.joining_date?.[0]}
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Gender</p>
                  <div className="relative">
                    <CustomSelect
                      options={genderOptions}
                      value={gender}
                      placeholder="Gender"
                      width="w-full"
                      height="h-[46px]"
                      fontSize="14px"
                      onChange={(op) => {
                        setEmployee({
                          ...employee,
                          gender: op.value,
                        });
                        if (fieldErrors.gender) {
                          setFieldErrors({
                            ...fieldErrors,
                            gender: undefined,
                          });
                        }
                      }}
                      error={Boolean(fieldErrors.gender)}
                      helperText={fieldErrors?.gender?.[0]}
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Place of Birth</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Place of Birth"
                      value={place_of_birth}
                      onChange={(e) => {
                        setEmployee({
                          ...employee,
                          place_of_birth: e.target.value,
                        });
                        if (fieldErrors.place_of_birth) {
                          setFieldErrors({
                            ...fieldErrors,
                            place_of_birth: undefined,
                          });
                        }
                      }}
                      error={Boolean(fieldErrors.place_of_birth)}
                      helperText={fieldErrors?.place_of_birth?.[0]}
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Marital Status</p>
                  <div className="relative">
                    <CustomSelect
                      options={maritalStatusOptions}
                      value={marital_status}
                      placeholder="Marital Status"
                      width="w-full"
                      height="h-[46px]"
                      fontSize="14px"
                      onChange={(op) => {
                        setEmployee({
                          ...employee,
                          marital_status: op.value,
                        });
                        if (fieldErrors.gender) {
                          setFieldErrors({
                            ...fieldErrors,
                            gender: undefined,
                          });
                        }
                      }}
                      error={Boolean(fieldErrors.gender)}
                      helperText={fieldErrors?.gender?.[0]}
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Password</p>
                  <div className="relative">
                    <Input
                      type={passwordShown ? "text" : "password"}
                      placeholder="Enter Password"
                      value={password}
                      onChange={(e) => {
                        setEmployee({ ...employee, password: e.target.value });
                        if (fieldErrors.password) {
                          setFieldErrors({
                            ...fieldErrors,
                            password: undefined,
                          });
                        }
                      }}
                      error={Boolean(fieldErrors.password)}
                      helperText={fieldErrors?.password?.[0]}
                    />
                    <div
                      className="absolute right-4 top-4 cursor-pointer"
                      onClick={handleClickShowPassword}
                    >
                      {passwordShown ? (
                        <FiEye color="#142b70" />
                      ) : (
                        <FiEyeOff color="#142b70" />
                      )}
                    </div>
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Confirm Password</p>
                  <div className="relative">
                    <Input
                      type={passwordShown ? "text" : "password"}
                      placeholder="Enter Password again"
                      value={con_password}
                      onChange={(e) => {
                        setEmployee({
                          ...employee,
                          con_password: e.target.value,
                        });
                        if (fieldErrors.con_password) {
                          setFieldErrors({
                            ...fieldErrors,
                            con_password: undefined,
                          });
                        }
                      }}
                      error={Boolean(fieldErrors.con_password)}
                      helperText={fieldErrors?.con_password?.[0]}
                    />
                    <div
                      className="absolute right-4 top-4 cursor-pointer"
                      onClick={handleClickShowPassword}
                    >
                      {passwordShown ? (
                        <FiEye color="#142b70" />
                      ) : (
                        <FiEyeOff color="#142b70" />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <PasswordRules
                  minchar={minchar}
                  upcase={upcase}
                  lowcase={lowcase}
                  number={number}
                  special={special}
                />
              </div>
            </div>

            {/* Form Col 2 */}
            <div className="flex flex-col flex-grow gap-6 w-full">
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Role</p>
                  <CustomSelect
                    options={roleOptions}
                    value={role_id}
                    placeholder="Role"
                    width="w-full"
                    height="h-[46px]"
                    fontSize="14px"
                    onChange={(op) => {
                      setEmployee({
                        ...employee,
                        role_id: op.value,
                        tl_id: 0,
                        hr_head: null,
                        manager: null,
                      });
                      if (fieldErrors.role_id) {
                        setFieldErrors({
                          ...fieldErrors,
                          role_id: undefined,
                        });
                      }
                    }}
                    error={Boolean(fieldErrors.role_id)}
                    helperText={fieldErrors?.role_id?.[0]}
                  />
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Designation</p>
                  <CustomSelect
                    options={designationOptions}
                    value={designation_id}
                    placeholder="Designation"
                    width="w-full"
                    height="h-[46px]"
                    fontSize="14px"
                    onChange={(op) => {
                      setEmployee({
                        ...employee,
                        designation_id: op.value,
                      });
                      if (fieldErrors.designation_id) {
                        setFieldErrors({
                          ...fieldErrors,
                          designation_id: undefined,
                        });
                      }
                    }}
                    error={Boolean(fieldErrors.designation_id)}
                    helperText={fieldErrors?.designation_id?.[0]}
                  />
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Grade</p>
                  <CustomSelect
                    options={gradeOptions}
                    value={grade_id}
                    placeholder="Grade"
                    width="w-full"
                    height="h-[46px]"
                    fontSize="14px"
                    onChange={(op) => {
                      setEmployee({
                        ...employee,
                        grade_id: op.value,
                      });
                      if (fieldErrors.grade_id) {
                        setFieldErrors({
                          ...fieldErrors,
                          grade_id: undefined,
                        });
                      }
                    }}
                    error={Boolean(fieldErrors.grade_id)}
                    helperText={fieldErrors?.grade_id?.[0]}
                  />
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Department</p>
                  <CustomSelect
                    options={departmentOptions}
                    value={department_id}
                    placeholder="Department"
                    width="w-full"
                    height="h-[46px]"
                    fontSize="14px"
                    onChange={(op) => {
                      setEmployee({
                        ...employee,
                        department_id: op.value,
                      });
                      if (fieldErrors.department_id) {
                        setFieldErrors({
                          ...fieldErrors,
                          department_id: undefined,
                        });
                      }
                    }}
                    error={Boolean(fieldErrors.department_id)}
                    helperText={fieldErrors?.department_id?.[0]}
                  />
                </div>
              </div>
              <div className="flex justify-between gap-5">
                {role_id === 3 ? (
                  <div className="flex flex-col gap-2 w-full">
                    <p className="text-sm text-[#142b70]/80">HR Head</p>
                    <CustomSelect
                      options={hrOptions}
                      value={hr_head}
                      placeholder="HR Head"
                      width="w-full"
                      height="h-[46px]"
                      fontSize="14px"
                      onChange={(op) => {
                        setEmployee({
                          ...employee,
                          hr_head: op.value,
                        });
                        if (fieldErrors.hr_head) {
                          setFieldErrors({
                            ...fieldErrors,
                            hr_head: undefined,
                          });
                        }
                      }}
                      error={Boolean(fieldErrors.hr_head)}
                      helperText={fieldErrors?.hr_head?.[0]}
                    />
                  </div>
                ) : role_id === 4 ? (
                  <div className="flex flex-col gap-2 w-full">
                    <p className="text-sm text-[#142b70]/80">Manager</p>
                    <CustomSelect
                      options={managerOptions}
                      value={manager}
                      placeholder="Manager"
                      width="w-full"
                      height="h-[46px]"
                      fontSize="14px"
                      onChange={(op) => {
                        setEmployee({
                          ...employee,
                          manager: op.value,
                        });
                        if (fieldErrors.manager) {
                          setFieldErrors({
                            ...fieldErrors,
                            manager: undefined,
                          });
                        }
                      }}
                      error={Boolean(fieldErrors.manager)}
                      helperText={fieldErrors?.manager?.[0]}
                    />
                  </div>
                ) : role_id === 8 ? (
                  <div className="flex flex-col gap-2 w-full">
                    <p className="text-sm text-[#142b70]/80">Team Leader</p>
                    <CustomSelect
                      options={tlOptions}
                      value={tl_id}
                      placeholder="Team Leader"
                      width="w-full"
                      height="h-[46px]"
                      fontSize="14px"
                      // disable={role_id !== 8}
                      onChange={(op) => {
                        setEmployee({
                          ...employee,
                          tl_id: op.value,
                        });
                        if (fieldErrors.tl_id) {
                          setFieldErrors({
                            ...fieldErrors,
                            tl_id: undefined,
                          });
                        }
                      }}
                      error={Boolean(fieldErrors.tl_id)}
                      helperText={fieldErrors?.tl_id?.[0]}
                    />
                  </div>
                ) : (
                  <></>
                )}
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">HR</p>
                  <CustomSelect
                    options={hrOptions}
                    value={hr_id}
                    placeholder="HR"
                    width="w-full"
                    height="h-[46px]"
                    fontSize="14px"
                    onChange={(op) => {
                      setEmployee({
                        ...employee,
                        hr_id: op.value,
                      });
                      if (fieldErrors.hr_id) {
                        setFieldErrors({
                          ...fieldErrors,
                          hr_id: undefined,
                        });
                      }
                    }}
                    error={Boolean(fieldErrors.hr_id)}
                    helperText={fieldErrors?.hr_id?.[0]}
                  />
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Job Location</p>
                  <CustomSelect
                    options={locationOptions}
                    value={location_id}
                    placeholder="Job Location"
                    width="w-full"
                    height="h-[46px]"
                    fontSize="14px"
                    onChange={(op) => {
                      setEmployee({
                        ...employee,
                        location_id: op.value,
                      });
                      if (fieldErrors.location_id) {
                        setFieldErrors({
                          ...fieldErrors,
                          location_id: undefined,
                        });
                      }
                    }}
                    error={Boolean(fieldErrors.location_id)}
                    helperText={fieldErrors?.location_id?.[0]}
                  />
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Nationality</p>
                  <CustomSelect
                    options={nationalityOptions}
                    value={nationality}
                    placeholder="Nationality"
                    width="w-full"
                    height="h-[46px]"
                    fontSize="14px"
                    onChange={(op) => {
                      setEmployee({
                        ...employee,
                        nationality: op.value,
                      });
                      if (fieldErrors.nationality) {
                        setFieldErrors({
                          ...fieldErrors,
                          nationality: undefined,
                        });
                      }
                    }}
                    error={Boolean(fieldErrors.nationality)}
                    helperText={fieldErrors?.nationality?.[0]}
                  />
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Salary</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Salary amount"
                      value={salary}
                      onChange={(e) => {
                        setEmployee({
                          ...employee,
                          salary: `${e.target.value}`,
                        });
                        if (fieldErrors.salary) {
                          setFieldErrors({
                            ...fieldErrors,
                            salary: undefined,
                          });
                        }
                      }}
                      error={Boolean(fieldErrors.salary)}
                      helperText={fieldErrors?.salary?.[0]}
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">
                    Employee Personal Number
                  </p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Employee Personal Number"
                      value={employee_personal_number}
                      onChange={(e) => {
                        setEmployee({
                          ...employee,
                          employee_personal_number: e.target.value,
                        });
                        if (fieldErrors.employee_personal_number) {
                          setFieldErrors({
                            ...fieldErrors,
                            employee_personal_number: undefined,
                          });
                        }
                      }}
                      error={Boolean(fieldErrors.employee_personal_number)}
                      helperText={fieldErrors?.employee_personal_number?.[0]}
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">
                    Bank Account Number
                  </p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Bank Account Number"
                      value={bank_account_number}
                      onChange={(e) => {
                        setEmployee({
                          ...employee,
                          bank_account_number: e.target.value,
                        });
                        if (fieldErrors.bank_account_number) {
                          setFieldErrors({
                            ...fieldErrors,
                            bank_account_number: undefined,
                          });
                        }
                      }}
                      error={Boolean(fieldErrors.bank_account_number)}
                      helperText={fieldErrors?.bank_account_number?.[0]}
                    />
                  </div>
                </div>
                {location_id === 2 ? (
                  <div className="flex flex-col gap-2 w-full">
                    <p className="text-sm text-[#142b70]/80">Bank IFSC Code</p>
                    <div className="relative">
                      <Input
                        type="text"
                        placeholder="Enter Bank IFSC Code"
                        value={ifsc_code}
                        onChange={(e) => {
                          setEmployee({
                            ...employee,
                            ifsc_code: e.target.value,
                          });
                          if (fieldErrors.ifsc_code) {
                            setFieldErrors({
                              ...fieldErrors,
                              ifsc_code: undefined,
                            });
                          }
                        }}
                        error={Boolean(fieldErrors.ifsc_code)}
                        helperText={fieldErrors?.ifsc_code?.[0]}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="flex flex-col gap-2 w-full">
                    <p className="text-sm text-[#142b70]/80">
                      Bank Routing Code
                    </p>
                    <div className="relative">
                      <Input
                        type="text"
                        placeholder="Enter Bank Routing Code"
                        value={bank_routing_code}
                        onChange={(e) => {
                          setEmployee({
                            ...employee,
                            bank_routing_code: e.target.value,
                          });
                          if (fieldErrors.bank_routing_code) {
                            setFieldErrors({
                              ...fieldErrors,
                              bank_routing_code: undefined,
                            });
                          }
                        }}
                        error={Boolean(fieldErrors.bank_routing_code)}
                        helperText={fieldErrors?.bank_routing_code?.[0]}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="flex justify-between gap-5">
                {location_id === 1 && (
                  <div className="flex flex-col gap-2 w-full">
                    <p className="text-sm text-[#142b70]/80">Emirates ID</p>
                    <div className="relative">
                      <Input
                        type="text"
                        placeholder="Enter your Emirates ID"
                        value={emirate_id}
                        onChange={(e) => {
                          setEmployee({
                            ...employee,
                            emirate_id: e.target.value,
                          });
                          if (fieldErrors.emirate_id) {
                            setFieldErrors({
                              ...fieldErrors,
                              emirate_id: undefined,
                            });
                          }
                        }}
                        error={Boolean(fieldErrors.emirate_id)}
                        helperText={fieldErrors?.emirate_id?.[0]}
                      />
                    </div>
                  </div>
                )}
                {location_id === 2 ? (
                  <div className="flex flex-col gap-2 w-full">
                    <p className="text-sm text-[#142b70]/80">Adhaar Number</p>
                    <div className="relative">
                      <Input
                        type="text"
                        placeholder="Enter Adhaar Number"
                        value={adharcard_no}
                        onChange={(e) => {
                          setEmployee({
                            ...employee,
                            adharcard_no: e.target.value,
                          });
                          if (fieldErrors.adharcard_no) {
                            setFieldErrors({
                              ...fieldErrors,
                              adharcard_no: undefined,
                            });
                          }
                        }}
                        error={Boolean(fieldErrors.adharcard_no)}
                        helperText={fieldErrors?.adharcard_no?.[0]}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="flex flex-col gap-2 w-full">
                    <p className="text-sm text-[#142b70]/80">Passport Number</p>
                    <div className="relative">
                      <Input
                        type="text"
                        placeholder="Enter Passport Number"
                        value={passport_no}
                        onChange={(e) => {
                          setEmployee({
                            ...employee,
                            passport_no: e.target.value,
                          });
                          if (fieldErrors.passport_no) {
                            setFieldErrors({
                              ...fieldErrors,
                              passport_no: undefined,
                            });
                          }
                        }}
                        error={Boolean(fieldErrors.passport_no)}
                        helperText={fieldErrors?.passport_no?.[0]}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Permanent Address</p>
                  <Textarea
                    value={permanent_address}
                    placeholder="Permanent Address"
                    onChange={(e) => {
                      sameAddress
                        ? setEmployee({
                            ...employee,
                            permanent_address: e.target.value,
                            current_address: e.target.value,
                          })
                        : setEmployee({
                            ...employee,
                            permanent_address: e.target.value,
                          });
                      if (fieldErrors.permanent_address) {
                        setFieldErrors({
                          ...fieldErrors,
                          permanent_address: undefined,
                        });
                      }
                    }}
                    error={Boolean(fieldErrors.permanent_address)}
                    helperText={fieldErrors?.permanent_address?.[0]}
                    rows={4}
                  />
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <label className="flex items-center gap-2 cursor-pointer text-sm text-[#142b70]/80">
                    <input
                      type="checkbox"
                      checked={sameAddress}
                      onChange={handleSameAddress}
                      className="h-4 w-4 accent-[#a48572] cursor-pointer"
                    />
                    Current address is same as Permanent address.
                  </label>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Current Address</p>
                  <Textarea
                    value={current_address}
                    placeholder="Current Address"
                    disable={sameAddress}
                    onChange={(e) => {
                      setEmployee({
                        ...employee,
                        current_address: e.target.value,
                      });
                      if (fieldErrors.current_address) {
                        setFieldErrors({
                          ...fieldErrors,
                          current_address: undefined,
                        });
                      }
                    }}
                    error={Boolean(fieldErrors.current_address)}
                    helperText={fieldErrors?.current_address?.[0]}
                    rows={4}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* Footer */}
          <div className="flex justify-end gap-4">
            <button
              className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium"
              onClick={handleAddEmployee}
            >
              Create
            </button>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default AddEmployee;
